module.exports = __webpack_public_path__ + "static/img/img_t2.727d804a.webp";